// Kuest card: bg-card, 1px border, rounded-xl, near-flat shadow.
function Card(props) {
  const { variant, extra, children, ...rest } = props;
  return (
    <div
      className={`!z-5 relative flex flex-col rounded-xl border border-border bg-card bg-clip-border text-card-foreground shadow-card ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
